import { motion } from "framer-motion";
import { feedback } from "../utils/interfaces";
import { FaQuoteLeft } from "react-icons/fa";

const FeedbackCard = ({
  image,
  username,
  position,
  content,
  company,
}: feedback) => {
  return (
    <motion.div
      className="group bg-gradient-to-br from-neutral-800/95 via-neutral-800 to-neutral-900/95 w-full max-w-none 500:max-w-[380px] mx-auto rounded-2xl 500:rounded-3xl p-3 400:p-4 500:p-6 700:p-8 relative shadow-xl hover:shadow-2xl hover:shadow-primary-500/20 transition-all duration-500 border border-neutral-700/50 backdrop-blur-sm hover:border-primary-500/50 flex flex-col h-full"
      whileHover={{ y: -4, scale: 1.01 }}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {/* Gradient overlay on hover */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
        initial={false}
      />

      {/* Decorative quote icon */}
      <div className="absolute top-3 500:top-4 700:top-6 right-3 500:right-4 700:right-6 opacity-10 group-hover:opacity-20 transition-opacity duration-300 pointer-events-none z-0">
        <FaQuoteLeft className="w-8 500:w-12 700:w-16 h-8 500:h-12 700:h-16 text-primary-400" />
      </div>

      {/* Company Badge */}
      <div className="absolute top-3 500:top-4 left-3 500:left-4 flex items-center gap-1.5 500:gap-2 z-10">
        <div className="w-6 500:w-7 700:w-8 h-6 500:h-7 700:h-8 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center shadow-lg">
          <span className="text-white font-poppins-bold text-[10px] 500:text-xs">N</span>
        </div>
        <span className="font-poppins-semi-bold text-[10px] 500:text-xs 700:text-sm text-primary-400 bg-gradient-to-r from-primary-500/10 to-primary-600/5 px-1.5 500:px-2 py-0.5 500:py-1 rounded-lg border border-primary-500/20">
          Nexasoft
        </span>
      </div>

      {/* Testimonial Content */}
      <div className="flex-1 mb-3 500:mb-4 700:mb-6 min-h-0 mt-8 500:mt-10 700:mt-12">
        <p className="text-neutral-200 text-xs 500:text-sm 700:text-base 900:text-lg font-poppins-regular leading-relaxed relative z-10 line-clamp-5 500:line-clamp-6">
          "{content}"
        </p>
      </div>

      {/* Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent mb-3 500:mb-4 700:mb-6" />

      {/* User Info */}
      <div className="flex items-center gap-2 500:gap-3 700:gap-4 flex-shrink-0">
        <motion.div
          className="relative flex-shrink-0"
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.3 }}
        >
          <img
            src={image}
            alt={username}
            className="w-10 500:w-12 700:w-14 h-10 500:h-12 700:h-14 rounded-full object-cover border-2 border-primary-500/50 shadow-lg group-hover:border-primary-400 transition-colors duration-300"
          />
          <div className="absolute -bottom-0.5 500:-bottom-1 -right-0.5 500:-right-1 w-3 500:w-4 700:w-5 h-3 500:h-4 700:h-5 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full border-2 border-neutral-800 flex items-center justify-center shadow-md">
            <div className="w-1 500:w-1.5 700:w-2 h-1 500:h-1.5 700:h-2 bg-white rounded-full" />
          </div>
        </motion.div>
        <div className="flex-1 min-w-0">
          <p className="font-poppins-semi-bold text-xs 500:text-sm 700:text-base text-neutral-100 truncate">
            {username}
          </p>
          <p className="font-poppins-regular text-[10px] 500:text-xs 700:text-sm text-neutral-400 truncate">
            {position}
          </p>
          <p className="font-poppins-medium text-[10px] 500:text-xs 700:text-sm text-primary-400 truncate">
            {company}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default FeedbackCard;
